import { useMemo } from "react";

import { InlineOptionsListControl } from "@/Common/Components/Inputs/InlineOptionsControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import { DirectoryEntityType } from "@/ContactDirectory/Api/medfar-contactdirectory/dist";

import styles from "./DirectoryTypeSelectionPopup.module.scss";

interface IDirectoryTypeSelectionPopupProps {
    type: DirectoryEntityType;
    onChange: (type: DirectoryEntityType) => void;
    options?: DirectoryEntityType[];
}

export function DirectoryTypeSelectionPopup(props: IDirectoryTypeSelectionPopupProps): JSX.Element {
    const { getText } = useTranslation();

    const options = useMemo(
        () => [
            new KeyValuePair(DirectoryEntityType.HealthcareProvider, getText("ProfessionalLabel")),
            new KeyValuePair(DirectoryEntityType.Pharmacy, getText("lblPharmacie")),
            new KeyValuePair(DirectoryEntityType.Other, getText("EstablishmentLabel"))
        ]
            .filter(p => !props.options || props.options.includes(p.Key)),
        [getText, props.options]
    );

    return (
        <div className={styles.typeSelectionContainer}>
            <label className={styles.typeOfEntrySelectorTitle}>
                {getText("TypeOfEntryLabel")}
            </label>
            <div className={styles.typeOfEntrySelectorRadio}>
                <InlineOptionsListControl
                    id="typeOfEntry"
                    items={options}
                    onChange={item => props.onChange(item.Key)}
                    value={props.type ?? DirectoryEntityType.Other}
                    style={{ marginRight: "10px", flexGrow: 1 }}
                    optionSpacing="10px"
                />
            </div>
        </div>
    );
}
